import api from './axios';
import { ProfileResponse, BusinessRequest } from './types';

const settingsApi = {
    // Fetch user profile details
    getProfile: async (): Promise<ProfileResponse> => {
        try {
            const response = await api.get<ProfileResponse>('/auth/user-info');
            console.log('Profile:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch profile info:', error);
            throw new Error('Failed to fetch profile info');
        }
    },

    // Update business information
    updateBusinessInfo: async (data: BusinessRequest): Promise<{ message: string }> => {
        try {
            const response = await api.put('/auth/business-info', data);
            return response.data;
        } catch (error: any) {
            console.error('Failed to update business info:', error);
            throw new Error('Failed to update business info');
        }
    },

    // Update contact (email and phone)
    updateContactInfo: async (data: { new_email: string | undefined; new_phone: string | undefined }): Promise<{ message: string }> => {
        try {
            const response = await api.put('/auth/update-contact-info', data);
            return response.data;
        } catch (error: any) {
            console.error('Failed to update contact info:', error);
            throw new Error('Failed to update contact info');
        }
    },

    syncQboBusinessInfo: async (): Promise<{ status: string; message: string; data: any }> => {
        try {
            const response = await api.post('/auth/qbo/sync-business-info');
            return response.data;
        } catch (error: any) {
            console.error('Failed to sync QBO business info:', error);
            throw error;
        }
    },

    disconnectQbo: async (): Promise<{ status: string; message: string }> => {
        try {
            const response = await api.delete('/auth/qbo/disconnect');
            return response.data;
        } catch (error: any) {
            console.error('Failed to disconnect QBO:', error);
            throw error;
        }
    }
};

export default settingsApi;
